(function ($) {
	$(document).ready(function () {
		if (typeof Swiper === 'undefined') return false;
		if (!$('.testimonials-carousel-inner-content-swiper').length) {
			return false;
		}

		$('.testimonials-carousel-inner').each(function () {
			new Swiper(
				$(this).find('.testimonials-carousel-inner-content-swiper')[0],
				{
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 16,
					loop: true,
					breakpoints: {
						768: {
							spaceBetween: 140,
						},
					},
					navigation: {
						nextEl: $(this).find(
							'.testimonials-carousel-inner-content-swiper-navigation-next'
						)[0],
						prevEl: $(this).find(
							'.testimonials-carousel-inner-content-swiper-navigation-prev'
						)[0],
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
						clickable: true,
					},
				}
			);
		});
	});
})(jQuery);
